export const featureAbbr = "share"